// front-end/multimodal/src/CloseIcon.tsx
import React, { useEffect } from 'react';
import './CloseIcon.css';

interface CloseIconProps {
    onClose: () => void;
    closeWithKeyboard?: boolean;
}

const CloseIcon: React.FC<CloseIconProps> = ({ onClose, closeWithKeyboard = true }) => {
    useEffect(() => {
        if (closeWithKeyboard) {
            const handleKeyDown = (event: KeyboardEvent) => {
                if (event.key === 'Escape') {
                    onClose();
                }
            };

            window.addEventListener('keydown', handleKeyDown);

            return () => {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [onClose, closeWithKeyboard]);

    return (
        <button title="Close" className="close-button" onClick={onClose}>X</button>
    );
}

export default CloseIcon;